import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function UrgencyBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const [count, setCount] = useState(9);
  useEffect(() => {
    if (!isVisible) return;
    const decreaseCount = () => {
      setCount(prev => {
        if (prev <= 3) return prev;
        return prev - 1;
      });
      // Schedule next decrease
      const nextInterval = Math.floor(Math.random() * (90000 - 45000 + 1)) + 45000; // 45 to 90 seconds
      setTimeout(decreaseCount, nextInterval);
    };
    const timer = setTimeout(decreaseCount, Math.floor(Math.random() * 20000) + 10000); // First decrease after 10-30s
    return () => clearTimeout(timer);
  }, [isVisible]);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-311">
      <motion.div initial={{
      y: -100
    }} animate={{
      y: 0
    }} exit={{
      y: -100
    }} className="fixed top-0 z-50 w-full bg-gradient-to-r from-red-900 via-red-800 to-red-900 border-b border-gold/30 shadow-lg" data-id="element-312">
        <div className="max-w-7xl mx-auto px-4 py-3 relative flex items-center justify-center text-center" data-id="element-313">
          <p className="text-white text-sm md:text-base font-medium" data-id="element-314">
            <span className="text-gold font-bold uppercase tracking-wider mr-2" data-id="element-315">
              Oferta de lanzamiento
            </span>
            <span className="hidden md:inline" data-id="element-316">·</span>
            <span className="mx-2" data-id="element-317">
              Últimos{' '}
              <motion.span key={count} initial={{
              scale: 1.5,
              color: '#D4AF37'
            }} animate={{
              scale: 1,
              color: '#ffffff'
            }} className="inline-block font-bold text-lg px-1" data-id="element-318">
                {count}
              </motion.span>{' '}
              mazos
            </span>
            <span className="hidden md:inline" data-id="element-319">·</span>
            <span className="ml-2 text-white/80" data-id="element-320">
              Después el precio sube a $42.000 pesos
            </span>
          </p>
          <button onClick={() => setIsVisible(false)} className="absolute right-4 top-1/2 -translate-y-1/2 text-white/50 hover:text-white transition-colors" data-id="element-321">
            <X className="w-5 h-5" data-id="element-322" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>;
}